// extracted by mini-css-extract-plugin
export default {"groupTabContainer":"GroupTab_groupTabContainer__Y2dxi","groupItem":"GroupTab_groupItem__RqsA2"};